import { captureEvent } from '@/core/posthog-init';

export type GuidanceAnalyticsEvent = {
  name: string;
  tourId?: string;
  stepId?: string;
  stepIndex?: number;
  metadata?: Record<string, unknown>;
};

/**
 * Guidance analytics without `@tour-kit/analytics` (its barrel dynamically
 * imports optional vendor SDKs and breaks Vite unless every peer is installed).
 * Console in dev + PostHog when configured.
 */
export function trackGuidanceEvent(event: GuidanceAnalyticsEvent): void {
  const name = event.name.startsWith('guidance.')
    ? event.name
    : `guidance.${event.name}`;

  const props = {
    tourId: event.tourId,
    stepId: event.stepId,
    stepIndex: event.stepIndex,
    ...event.metadata,
  };

  if (import.meta.env.DEV) {
    console.info('[guidance]', { ...event, name });
  }

  captureEvent(name, props);
}
